import React from 'react';
import { useSelector } from 'react-redux';
import Text from '../../../../shared/components/Text/Text';

const SideBarTitleWrapper = () => {
  const sideBarDataTag = useSelector((state) => state.calendar.data.primarySideBarDataTag);

  const getTitle = () => {
    switch (sideBarDataTag) {
      case 'tag':
        return 'Tag';
      case 'comment':
        return 'Comment';
      case 'folder':
        return 'Folder';
      case 'lift':
        return 'Exercises';
      case 'checkmark':
        return 'Checkmark';
      default:
        return '';
    }
  };

  if (sideBarDataTag !== 'calendar2') {
    return (
      <Text fontWeight={700} fontSize='13px'>{getTitle()}</Text>
    );
  }
  return null;
};

export default SideBarTitleWrapper;
